export default {_name:'text.status',module:'Field',view:'Element/Text/Status',options:{md:'auto'},mobileOptions:{md:'auto'}}